import { ApexOptions } from 'apexcharts';
import { Col, Row } from 'react-bootstrap';
import { formatPrice } from '../../../utils/utils';

const DonutCustomLegend = (props: {
  options: ApexOptions;
  starredCategory?: string;
  hideBenefitText?: boolean;
  hideAmount?: boolean;
  isFooterRowTransparent?: boolean;
}) => {
  const series = props.options?.series ?? [];
  const labels = props.options?.labels ?? [];
  const colours = props.options?.colors ?? [];

  const getDonutLegendItems = () => {
    var items = series.map((item, index) => {
      return {
        id: index,
        value: item,
        label: labels[index],
        colour: colours[index],
      };
    });
    return items;
  };

  const showLegendTitleRow = !props.hideAmount || !props.hideBenefitText;

  return (
    <>
      <Row>
        <Col>
          {showLegendTitleRow && (
            <Row className="fw-light pt-3 px-3 lh-xs border-bottom">
              <Col className="text-sm-12-lg-14 text-ligther-grey ps-0 fw-light">
                {props.hideBenefitText ? null : 'Benefits'}
              </Col>
              <Col className="text-sm-12-lg-14 text-ligther-grey text-end fw-light pe-0">
                {props.hideAmount ? null : 'Amount'}
              </Col>
            </Row>
          )}
          {getDonutLegendItems().map((item) => (
            <Row
              key={item.id}
              className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom"
            >
              <Col className="pt-1 ps-0 col-1">
                <div
                  className="custom-legend-marker"
                  style={{
                    backgroundColor: item.colour.toString(),
                  }}
                ></div>
              </Col>
              <Col className="col-8 ps-0 ">{item.label}</Col>
              <Col className="col-3 fw-normal text-end pe-0">
                {props?.starredCategory !== item.label
                  ? `${formatPrice(Number(item.value), 'en-US', {
                      currency: 'USD',
                      style: 'currency',
                      minimumFractionDigits: 0,
                    })}`
                  : '*'}
              </Col>
            </Row>
          ))}
          <Row
            className={
              'text-fs-6 fw-normal lh-xs pt-3 pb-3 pe-lg-0 pe-3  ' +
              (props.isFooterRowTransparent === true
                ? ''
                : 'custom-donut-legend-total-row border-bottom')
            }
          >
            <Col className="pt-1 ps-3">Total</Col>
            <Col className="col-3 text-end px-3">
              {props.options.plotOptions?.pie?.donut?.labels?.total?.label}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default DonutCustomLegend;
